import { __decorate } from "tslib";
import { AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
export const id_certificateTemplate = "1.3.6.1.4.1.311.21.7";
export class CertificateTemplate {
    constructor(params = {}) {
        this.templateID = "";
        this.templateMajorVersion = 0;
        this.templateMinorVersion = 0;
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], CertificateTemplate.prototype, "templateID", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], CertificateTemplate.prototype, "templateMajorVersion", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], CertificateTemplate.prototype, "templateMinorVersion", void 0);
